import { MiniCart } from "@/components/Cart/MiniCart/miniCart.container";
import { useCartButtonContext } from "@/components/Navigation/Buttons/CartButton/context/cartButton.context";
import { useHeaderButtonContext } from "@/components/Navigation/Buttons/HeaderButton/context/headerButton.context";

export const Content = () => {
    const { redirect, isUpdatingCart, activeId, onRemoveFromCart } =
        useCartButtonContext();
    const { onCloseMenu } = useHeaderButtonContext();

    return (
        <MiniCart
            removeFromCart={onRemoveFromCart}
            urlTarget={redirect}
            isUpdatingCart={isUpdatingCart}
            closeCallback={onCloseMenu}
            activeId={activeId}
        />
    );
};
